import _regeneratorRuntime from "/codebuild/output/src386676321/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";

var _marked =
/*#__PURE__*/
_regeneratorRuntime.mark(runRequestBronzeCheck),
    _marked2 =
/*#__PURE__*/
_regeneratorRuntime.mark(handleRequestBronzeCheck),
    _marked3 =
/*#__PURE__*/
_regeneratorRuntime.mark(runRequestBronzeEntry),
    _marked4 =
/*#__PURE__*/
_regeneratorRuntime.mark(handleRequestBronzeEntry),
    _marked5 =
/*#__PURE__*/
_regeneratorRuntime.mark(runSuccessBronzeEntry),
    _marked6 =
/*#__PURE__*/
_regeneratorRuntime.mark(handleSuccessBronzeEntry),
    _marked7 =
/*#__PURE__*/
_regeneratorRuntime.mark(runFailureBronzeEntry),
    _marked8 =
/*#__PURE__*/
_regeneratorRuntime.mark(handleFailureBronzeEntry),
    _marked9 =
/*#__PURE__*/
_regeneratorRuntime.mark(runRequestBronzePayment),
    _marked10 =
/*#__PURE__*/
_regeneratorRuntime.mark(handleRequestBronzePayment),
    _marked11 =
/*#__PURE__*/
_regeneratorRuntime.mark(runSuccessBronzePayment),
    _marked12 =
/*#__PURE__*/
_regeneratorRuntime.mark(handleSuccessBronzePayment),
    _marked13 =
/*#__PURE__*/
_regeneratorRuntime.mark(runFailureBronzePayment),
    _marked14 =
/*#__PURE__*/
_regeneratorRuntime.mark(handleFailureBronzePayment),
    _marked15 =
/*#__PURE__*/
_regeneratorRuntime.mark(rootSagas);

import * as actions from '../actions/bronze_test';
import { call, put, fork, takeLatest } from 'redux-saga/effects';
import { getBronzeCheck, getBronzePayment, sendBronzeEntry } from '../models/bronze_test';
export function runRequestBronzeCheck() {
  var _ref, payload, error;

  return _regeneratorRuntime.wrap(function runRequestBronzeCheck$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return call(getBronzeCheck);

        case 2:
          _ref = _context.sent;
          payload = _ref.payload;
          error = _ref.error;

          if (!(payload && !error)) {
            _context.next = 10;
            break;
          }

          _context.next = 8;
          return put(actions.successBronzeCheck(payload));

        case 8:
          _context.next = 12;
          break;

        case 10:
          _context.next = 12;
          return put(actions.failureBronzeCheck(error));

        case 12:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}
export function handleRequestBronzeCheck() {
  return _regeneratorRuntime.wrap(function handleRequestBronzeCheck$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return takeLatest(actions.requestBronzeCheck.type, runRequestBronzeCheck);

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}
export function runRequestBronzeEntry(action) {
  var _ref2, payload, error;

  return _regeneratorRuntime.wrap(function runRequestBronzeEntry$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return call(sendBronzeEntry, action.payload.request);

        case 2:
          _ref2 = _context3.sent;
          payload = _ref2.payload;
          error = _ref2.error;

          if (!(payload && !error)) {
            _context3.next = 10;
            break;
          }

          _context3.next = 8;
          return put(actions.successBronzeEntry(action.payload.callback));

        case 8:
          _context3.next = 12;
          break;

        case 10:
          _context3.next = 12;
          return put(actions.failureBronzeEntry({
            error: error,
            callback: action.payload.failureCallback
          }));

        case 12:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}
export function handleRequestBronzeEntry() {
  return _regeneratorRuntime.wrap(function handleRequestBronzeEntry$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return takeLatest(actions.requestBronzeEntry.type, runRequestBronzeEntry);

        case 2:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4);
}
export function runSuccessBronzeEntry(action) {
  return _regeneratorRuntime.wrap(function runSuccessBronzeEntry$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return call(action.payload);

        case 2:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5);
}
export function handleSuccessBronzeEntry() {
  return _regeneratorRuntime.wrap(function handleSuccessBronzeEntry$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return takeLatest(actions.successBronzeEntry.type, runSuccessBronzeEntry);

        case 2:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6);
}
export function runFailureBronzeEntry(action) {
  return _regeneratorRuntime.wrap(function runFailureBronzeEntry$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return call(action.payload.callback, action.payload.error);

        case 2:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked7);
}
export function handleFailureBronzeEntry() {
  return _regeneratorRuntime.wrap(function handleFailureBronzeEntry$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return takeLatest(actions.failureBronzeEntry.type, runFailureBronzeEntry);

        case 2:
        case "end":
          return _context8.stop();
      }
    }
  }, _marked8);
}
export function runRequestBronzePayment(action) {
  var _ref3, payload, error, actionUrl, formData;

  return _regeneratorRuntime.wrap(function runRequestBronzePayment$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return call(getBronzePayment, action.payload.request);

        case 2:
          _ref3 = _context9.sent;
          payload = _ref3.payload;
          error = _ref3.error;

          if (!(payload && !error)) {
            _context9.next = 13;
            break;
          }

          actionUrl = payload['action_url'];
          formData = Object.assign({}, payload);
          delete formData['action_url'];
          _context9.next = 11;
          return put(actions.successBronzePayment({
            payment: {
              formData: formData,
              url: actionUrl
            },
            callback: action.payload.callback
          }));

        case 11:
          _context9.next = 15;
          break;

        case 13:
          _context9.next = 15;
          return put(actions.failureBronzePayment({
            error: error,
            callback: action.payload.failureCallback
          }));

        case 15:
        case "end":
          return _context9.stop();
      }
    }
  }, _marked9);
}
export function handleRequestBronzePayment() {
  return _regeneratorRuntime.wrap(function handleRequestBronzePayment$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return takeLatest(actions.requestBronzePayment.type, runRequestBronzePayment);

        case 2:
        case "end":
          return _context10.stop();
      }
    }
  }, _marked10);
}
export function runSuccessBronzePayment(action) {
  return _regeneratorRuntime.wrap(function runSuccessBronzePayment$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return call(action.payload.callback, action.payload.payment);

        case 2:
        case "end":
          return _context11.stop();
      }
    }
  }, _marked11);
}
export function handleSuccessBronzePayment() {
  return _regeneratorRuntime.wrap(function handleSuccessBronzePayment$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          _context12.next = 2;
          return takeLatest(actions.successBronzePayment.type, runSuccessBronzePayment);

        case 2:
        case "end":
          return _context12.stop();
      }
    }
  }, _marked12);
}
export function runFailureBronzePayment(action) {
  return _regeneratorRuntime.wrap(function runFailureBronzePayment$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          _context13.next = 2;
          return call(action.payload.callback, action.payload.error);

        case 2:
        case "end":
          return _context13.stop();
      }
    }
  }, _marked13);
}
export function handleFailureBronzePayment() {
  return _regeneratorRuntime.wrap(function handleFailureBronzePayment$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          _context14.next = 2;
          return takeLatest(actions.failureBronzePayment.type, runFailureBronzePayment);

        case 2:
        case "end":
          return _context14.stop();
      }
    }
  }, _marked14);
}
export default function rootSagas() {
  return _regeneratorRuntime.wrap(function rootSagas$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          _context15.next = 2;
          return fork(handleRequestBronzeCheck);

        case 2:
          _context15.next = 4;
          return fork(handleRequestBronzeEntry);

        case 4:
          _context15.next = 6;
          return fork(handleRequestBronzePayment);

        case 6:
          _context15.next = 8;
          return fork(handleSuccessBronzeEntry);

        case 8:
          _context15.next = 10;
          return fork(handleSuccessBronzePayment);

        case 10:
          _context15.next = 12;
          return fork(handleFailureBronzeEntry);

        case 12:
          _context15.next = 14;
          return fork(handleFailureBronzePayment);

        case 14:
        case "end":
          return _context15.stop();
      }
    }
  }, _marked15);
}